import { render, staticRenderFns } from "./news.vue?vue&type=template&id=c2222b20&scoped=true&"
import script from "./news.vue?vue&type=script&lang=js&"
export * from "./news.vue?vue&type=script&lang=js&"
import style0 from "./news.vue?vue&type=style&index=0&id=c2222b20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2222b20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2222b20')) {
      api.createRecord('c2222b20', component.options)
    } else {
      api.reload('c2222b20', component.options)
    }
    module.hot.accept("./news.vue?vue&type=template&id=c2222b20&scoped=true&", function () {
      api.rerender('c2222b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/search2/news.vue"
export default component.exports